import {
  Box,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  Typography,
  useTheme,
} from '@mui/material';
import DefaultLogo from '@shared/assets/air/iconBlack.png';
import { sxStyled } from './styles';

const FilterAeroline = ({ flightFilters }) => {
  const theme = useTheme();
  const sxStyle = sxStyled(theme);

  const { allAirline, airlineSelected, carrierHandleChange } = flightFilters;

  return (
    <Grid item lg={12} sm={12} xs={12} sx={sxStyle.filterBox}>
      <Typography sx={{ fontSize: 15, color: 'black', fontWeight: 600 }}>
        Aerolíneas
      </Typography>

      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        {/* Todas las aerolíneas */}
        <FormControlLabel
          sx={{
            ...sxStyle.formControlLabelRoot,
            '& .MuiFormControlLabel-label': sxStyle.formControlLabel,
          }}
          control={
            <Checkbox
              checked={airlineSelected?.includes('allOptions')}
              name="allOptions"
              sx={{
                fontFamily: 'Open Sans',
                color: theme.tertiary,
                '&.Mui-checked': { color: theme.tertiary },
              }}
              onChange={() => carrierHandleChange('allOptions')}
            />
          }
          label="Todas las Aerolíneas"
        />

        {/* Aerolíneas individuales */}
        {allAirline?.map(carrier => {
          const cluster = carrier?.combinations
            ? carrier.combinations[0].cluster
            : carrier.cluster;

          return (
            <FormControlLabel
              key={cluster.carrier.code || cluster.carrier.id}
              sx={{
                ...sxStyle.formControlLabelRoot,
                '& .MuiFormControlLabel-label': sxStyle.formControlLabel,
                fontFamily: 'Open Sans',
              }}
              control={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <Checkbox
                    checked={airlineSelected.includes(cluster.carrier)}
                    name={String(cluster.carrier)}
                    sx={{
                      fontFamily: 'Open Sans',
                      color: theme.tertiary,
                      '&.Mui-checked': { color: theme.tertiary },
                    }}
                    onChange={() => carrierHandleChange(cluster.carrier)}
                  />
                  <Box
                    component="img"
                    src={cluster.carrier.logo || DefaultLogo}
                    alt={cluster.carrier.description || cluster.carrier.code}
                    sx={{ width: 30, height: 30 }}
                  />
                  <Box component="span" sx={{ textTransform: 'capitalize' }}>
                    {cluster.carrier.description || cluster.carrier.code}
                  </Box>
                </Box>
              }
              label=""
            />
          );
        })}
      </Box>

      <Divider sx={sxStyle.filterBoxDivider} />
    </Grid>
  );
};

export default FilterAeroline;
